import * as React from 'react'
import { Descriptions, Space, Typography } from 'antd'

import { CheckTransactionHashResponse } from '../../types'
import { AmlCheckCountdown } from '../AmlCheckCountdown'

type TransactionResultProps = {
  result: CheckTransactionHashResponse
  amlCheckRefreshing: boolean
  hasError: boolean
  onAmlCheckRefresh: () => void
}

export const TransactionResult: React.FC<TransactionResultProps> = ({
  result,
  amlCheckRefreshing,
  hasError,
  onAmlCheckRefresh,
}) => {
  const { transaction, aml } = result

  const showAmlCheckCountdown =
    aml.status === 'CHECKING' && !amlCheckRefreshing && !hasError

  return (
    <Descriptions column={1} bordered size="small">
      <Descriptions.Item label="Хеш">
        <Typography.Text copyable>{transaction.hash}</Typography.Text>
      </Descriptions.Item>
      <Descriptions.Item label="Сеть">{transaction.network}</Descriptions.Item>
      <Descriptions.Item label="Валюта">
        {transaction.currency}
      </Descriptions.Item>
      <Descriptions.Item label="Отправитель">
        <Typography.Text copyable>{transaction.from}</Typography.Text>
      </Descriptions.Item>
      <Descriptions.Item label="Получатель">
        <Typography.Text copyable>{transaction.to}</Typography.Text>
      </Descriptions.Item>
      <Descriptions.Item label="Сумма">
        {transaction.amount} {transaction.currency}
      </Descriptions.Item>
      <Descriptions.Item label="Дата">
        {new Date(transaction.occurredAt).toLocaleString('ru-RU')}
      </Descriptions.Item>
      <Descriptions.Item label="Статус в блокчейне">
        {transaction.blockchainStatus}
      </Descriptions.Item>
      <Descriptions.Item label="Номер блока">
        {transaction.blockNumber}
      </Descriptions.Item>
      <Descriptions.Item label="Транзакция в блокчейне">
        <a href={transaction.explorerUrl} target="_blank" rel="noreferrer">
          Посмотреть в блокчейне
        </a>
      </Descriptions.Item>
      <Descriptions.Item label="ID AML-проверки">
        {aml.checkId}
      </Descriptions.Item>
      <Descriptions.Item label="Статус AML-проверки">
        <Space>
          {aml.status}
          {showAmlCheckCountdown && (
            <AmlCheckCountdown onFinish={onAmlCheckRefresh} />
          )}
          {amlCheckRefreshing && (
            <Typography.Text type="secondary">
              Обновляем статус…
            </Typography.Text>
          )}
        </Space>
      </Descriptions.Item>
      {aml.result && (
        <>
          <Descriptions.Item label="AML-скоринг">
            {aml.result.amlScore}
          </Descriptions.Item>
          <Descriptions.Item label="Уровень риска">
            {aml.result.riskStatus}
          </Descriptions.Item>
          <Descriptions.Item label="Признаки риска">
            {aml.result.riskFlags.map((flag, index) => (
              <div key={index}>
                <strong>
                  {flag.category} / {flag.signal}
                </strong>
                : {flag.description}
              </div>
            ))}
          </Descriptions.Item>
          <Descriptions.Item label="Дата AML-проверки">
            {new Date(aml.result.checkedAt).toLocaleString('ru-RU')}
          </Descriptions.Item>
        </>
      )}
    </Descriptions>
  )
}
